import React from "react";
import { useNavigate } from "react-router-dom";
import { SITE, BRAND_TILES } from "../mock";

const LeafIcon = () => (
  <svg width="38" height="38" viewBox="0 0 56 56" className="mx-auto">
    <path
      d="M28 10 C18 16, 14 28, 22 40 C18 32, 22 22, 28 18 C34 22, 38 32, 34 40 C42 28, 38 16, 28 10 Z"
      fill="#c8232c"
    />
  </svg>
);

const AboutBrand = () => {
  const navigate = useNavigate();

  return (
    <section id="about" className="py-20 lg:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <LeafIcon />
          <p className="mt-6 text-stone-600 text-base md:text-lg leading-relaxed">
            {SITE.description}
          </p>
          <div className="nut-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-7">
          {BRAND_TILES.map((t) => (
            <button
              key={t.id}
              onClick={() => navigate(t.href)}
              className="brand-tile group block w-full overflow-hidden text-left"
            >
              <div className="relative aspect-[16/9] bg-stone-100">
                <img
                  src={t.image}
                  alt={t.label}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="label">
                  <div className="font-display text-2xl md:text-3xl">{t.label}</div>
                  <div className="text-xs uppercase tracking-[0.25em] mt-1 text-white/80">
                    Discover the range
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutBrand;
